<template>
  <div>
    <b-tabs class="ms-3">
      <b-tab title="Клиєнт" active>
        <b-row class="mt-3">
          <b-col sm="auto" xl="3">
            <b-button
              size="md"
              variant="primary"
              class="mt-2"
              v-on:click="toggleInputs"
              >Редагувати
              <b-icon icon="info-circle"></b-icon>
            </b-button>
          </b-col>
          <b-col sm="auto" xl="3">
            <client-card-seller
              v-on:refresh="getClient(clientId)"
              v-bind:client-id="clientId"
              v-on:showModal="showAlert"
              class="mt-2"
            >
            </client-card-seller>
          </b-col>
          <b-col sm="auto" xl="3">
            <b-button @click="openSeller" class="mt-2" variant="success">
              Разова послуга
              <b-icon class="ms-1" icon="cart-check-fill"></b-icon>
            </b-button>
          </b-col>
          <b-col sm="auto" xl="3" v-if="user[0].role == 'superadmin'">
            <button
              class="bg-red-400 py-1.5 px-2 mt-2 rounded text-white"
              v-on:click="deleteClient(clientId)"
            >
              Видалити
            </button>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <client-profile
            v-bind:client="client"
            v-on:refresh="getClient(clientId)"
            v-on:showAlert="showAlert"
            v-bind:input-state="inputState"
          >
          </client-profile>
        </b-row>
        <b-row class="me-4 mt-5">
          <div
            class="col-sm-auto col-lg-4"
            v-for="card in activeCards"
            :key="card.visits"
          >
            <client-active-card
              class="mb-3"
              v-on:refresh="getClient(clientId)"
              v-on:showModal="showAlert"
              v-on:openControls="openControlPanel"
              v-bind:client-id="clientId"
              v-bind:card="card"
            />
          </div>
        </b-row>
      </b-tab>
      <b-tab title="Карти">
        <cards-table
          v-bind:client="client"
          v-on:refresh="getClient(clientId)"
          v-on:showModal="showAlert"
        />
      </b-tab>
      <b-tab title="Візити">
        <visits-table v-bind:client-id="clientId" />
      </b-tab>
    </b-tabs>
    <client-card-controls
      v-if="chosenCard"
      v-on:refresh="getClient(clientId)"
      v-bind:card="chosenCard"
      v-on:showModal="showAlert"
      v-bind:client="client"
      v-bind:active-tab="controlTab"
    />

    <info-alert
      :class="alertClass"
      v-bind:text="alertText"
      v-bind:active-error="activeAlert"
    />
  </div>
</template>

<script>
import ClientProfile from "@/components/ClientPage/ClientProfile";
import ClientActiveCard from "@/components/ClientPage/ClientActiveCard";
import ClientCardSeller from "@/components/ClientPage/modals/ClientCardSeller";
import ClientCardControls from "@/components/ClientPage/modals/ClientCardControls";
import InfoAlert from "@/components/Toasts/InfoAlert";
import CardsTable from "@/components/ClientPage/CardsTable";
import VisitsTable from "@/components/ClientPage/VisitsTable";
import { mapState } from "vuex/dist/vuex.common.js";

export default {
  name: "ClientView",
  props: {
    clientId: Number,
  },
  components: {
    VisitsTable,
    CardsTable,
    ClientCardControls,
    ClientCardSeller,
    ClientProfile,
    ClientActiveCard,
    InfoAlert,
  },
  data: function () {
    return {
      client: {},
      inputState: true,
      chosenCard: null,
      controlTab: 1,
      alertClass: "",
      alertText: "",
      activeAlert: false,
    };
  },
  async mounted() {
    await this.getClient(this.clientId);
  },
  computed: {
    ...mapState(["user"]),
    activeCards: function () {
      if (!this.client.cards) {
        return;
      }
      return this.client.cards.filter(
        (card) => card.status === "ACTIVE" || card.status === "NOT ACTIVE",
      );
    },
  },
  watch: {
    clientId: async function (newVal) {
      await this.getClient(newVal);
    },
  },
  methods: {
    async getClient(clientId) {
      let response = await this.$api.clients.getClient(clientId);
      this.client = response.data;
    },
    async deleteClient(clientId) {
      let result = confirm("Ви впевнені, що хочете видалити цього клієнта?");
      if (!result) return;
      let response = await this.$api.clients.deleteClient(clientId);
      if (response instanceof Error) {
        this.showAlert(response.response.data.message, "red");
        return;
      }
      this.showAlert("Клієнта видалено", "green");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    toggleInputs() {
      this.inputState = !this.inputState;
    },
    openControlPanel(card, tab) {
      this.chosenCard = card;
      this.controlTab = tab;
      this.$nextTick(() => {
        this.$bvModal.show("modal-active-card-patch");
      });
    },
    showAlert(text, color) {
      this.activeAlert = true;
      this.alertClass = color;
      this.alertText = text;
      setTimeout(() => {
        this.activeAlert = false;
      }, 4000);
    },
    openSeller() {
      this.$emit("openSeller", this.client.id);
    },
  },
};
</script>

<style scoped></style>
